export const getTicketWorklogsImportFields = (currentProduct) => {
  const ticketWorklogsFields = [
    {
      label: 'attribute.ticket.referenceId',
      key: 'ticketSourceReferenceId',
      type: 'string',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'attribute.afterHours',
      key: 'afterHours',
      type: 'select',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ],
      selectOptions: [
        {
          label: 'app.common.true',
          value: 'true'
        },
        {
          label: 'app.common.false',
          value: 'false'
        }
      ]
    },
    // {
    //   label: 'dromo.title.billDate',
    //   key: 'billDateTime',
    //   type: 'string',
    //   validators: [
    //     {
    //       validate: 'regex_match',
    //       regex:
    //         '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$',
    //       errorMessage: 'dromo.validation.dateTime'
    //     },
    //     {
    //       validate: 'required',
    //       errorMessage: 'dromo.validation.requiredField'
    //     }
    //   ]
    // },
    {
      label: 'attribute.notes',
      key: 'notes',
      type: 'string',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'metric.quantity.unitsOrHours',
      key: 'quantity',
      type: [
        'number',
        {
          round: 2
        }
      ],
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'entityAttribute.technician.email',
      key: 'technician',
      type: 'string',
      validators: [
        {
          validate: 'regex_match',
          // prettier-ignore
          regex: '^([a-zA-Z0-9_+\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$',
          errorMessage: 'domain.validation.emailAddress'
        },
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'attribute.eventStartDateTime',
      key: 'startTime',
      type: 'string',
      validators: [
        {
          validate: 'regex_match',
          regex:
            '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?$',
          errorMessage: 'dromo.validation.dateTime'
        },
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'attribute.eventEndDateTime',
      key: 'endTime',
      type: 'string',
      validators: [
        {
          validate: 'regex_match',
          regex:
            '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?$',
          errorMessage: 'dromo.validation.dateTime'
        },
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    }
  ];
  if (currentProduct === 'MSP') {
    ticketWorklogsFields.push(
      {
        label: 'attribute.billable',
        key: 'billable',
        type: 'select',
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          }
        ],
        selectOptions: [
          {
            label: 'app.common.true',
            value: 'true'
          },
          {
            label: 'app.common.false',
            value: 'false'
          }
        ]
      },
      {
        label: 'metric.quantity.actualUnitsOrHours',
        key: 'revisedQuantity',
        type: [
          'number',
          {
            round: 2
          }
        ]
      },
      {
        label: 'attribute.unitPrice',
        key: 'unitPrice',
        type: [
          'number',
          {
            round: 4
          }
        ],
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          }
        ]
      },
      {
        label: 'dromo.title.revisedAmount',
        key: 'revisedAmount',
        type: [
          'number',
          {
            round: 4
          }
        ]
      },
      {
        label: 'client.contractTemplate.serviceCatalogSheet.header',
        key: 'serviceCatalogItem',
        type: 'string',
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          }
        ]
      }
    );
  }
  return ticketWorklogsFields;
};
